import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/ui` - старый адрес витрины, оставленный перенаправлением.
 *
 * Витрина жила здесь, пока `/design-system` занимала прежняя страница. Адрес разошёлся по
 * закладкам и переписке, поэтому он не удалён: ссылка из чата полугодовой давности должна
 * открывать витрину, а не «страница не найдена».
 */
export const Route = createFileRoute('/{-$locale}/_layout/ui')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/{-$locale}/design-system', params });
  },
});
